import React, { useState, useEffect } from 'react';
import './Intro.css';

const Intro = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Small delay before calling onComplete to allow fade-out animation
      setTimeout(() => {
        onComplete();
      }, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const handleSkip = () => {
    setIsVisible(false);
    setTimeout(() => {
      onComplete();
    }, 100);
  };

  return (
    <div className={`intro ${isVisible ? 'visible' : 'hidden'}`}>
      <button 
        className="intro-skip" 
        onClick={handleSkip}
        aria-label="Skip intro and go to website"
        title="Press Enter or click to skip"
      >
        Skip
      </button>
      <div className="intro-content">
        <h1 className="intro-title">Ruma Palace</h1>
        <p className="intro-subtitle">Loading your experience...</p>
      </div>
    </div>
  );
};

export default Intro;

